import React, { useEffect, useState } from 'react';
import {
  Item,
  List,
  Box,
  Typography,
  Icon,
  TextField,
  Button,
} from '@worthy-npm/worthy-common-ui-components';
import { NextStepButton, Step, StepContainer, StepGridContainer } from '../../../styles/common';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectBrand, selectModel, updateModel } from '../../../slices/submitSlice';
import { FormContent, FormWrap, StepProps } from '../common';
import { parametrize } from '../../../lib/commonUtils';
import StepTitle from '../../stepTitle';
import GA from '../../../data/GA';
import { ModelByBrand } from '../../../data/ItemDetails';

function StepModel({ next, active, idx, stepName, prev, title, stepCaption, props }: StepProps) {
  const dispatch = useAppDispatch();
  const brand = useAppSelector(selectBrand);
  const model = useAppSelector(selectModel);
  const [busy, setBusy] = useState(false);
  const [customModel, setCustomModel] = useState(model);
  const step = 'model';

  // @ts-ignore
  const modelByBrand = ModelByBrand[brand] || [];

  const modelByBrandSorted = modelByBrand.sort((current: string, nextVal: string) => {
    if (current === 'Other') return 1;
    if (nextVal === 'Other') return -1;
    return current.localeCompare(nextVal);
  });

  useEffect(() => {
    if (!active) return;
    GA.stepView(step);
  }, [active]);

  const onUpdate = (e: any, item: string, wait: number) => {
    if (busy) return;
    setBusy(true);

    dispatch(updateModel(item));
    GA.select({ step, value: item });
    setTimeout(() => {
      next(e);
      setTimeout(() => {
        setBusy(false);
      }, wait);
    }, wait);
  };

  return (
    <StepContainer data-automation="model-material-step">
      <Step>
        <StepTitle
          idx={idx}
          prev={prev}
          stepCaption={stepCaption}
          stepTitle={title || 'What is your watch model?'}
          stepName={stepName}
          stepNotice={brand === 'other' ? 'Please enter model name' : 'Select an option below'}
          optionalProps={props || {}}
        />

        <StepGridContainer>
          <List spacing={2}>
            {brand === 'other' ? (
              <FormWrap>
                <FormContent
                  active
                  data-testid="model-input-form"
                  data-automation="model-input-form"
                  style={{ height: '64px' }}
                >
                  <TextField
                    fullWidth
                    style={{ padding: '2px 4px' }}
                    inputProps={{ maxLength: 25 }}
                    data-automation="model-input"
                    variant="outlined"
                    value={customModel}
                    onChange={(e) => {
                      setCustomModel(e.target.value);
                    }}
                  />
                </FormContent>
              </FormWrap>
            ) : (
              modelByBrandSorted.map((item: string) => (
                <Item
                  data-automation={`model-material-step-item-${parametrize(item)}`}
                  key={item}
                  variant="outlined"
                  onClick={(e) => {
                    onUpdate(e, item, 600);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                  >
                    <Box display="flex" flexDirection="row" alignItems="center">
                      <Typography
                        variant="subtitle1"
                        color="text.primary"
                        paddingLeft="12px"
                        textTransform="capitalize"
                      >
                        {item}
                      </Typography>
                    </Box>
                    <Box data-automation="model-material-step-item-checked">
                      {item === model ? <Icon.GreenCheck display="block" /> : null}
                    </Box>
                  </Box>
                </Item>
              ))
            )}
          </List>

          <NextStepButton>
            {brand === 'other' ? (
              <Button
                disableElevation
                data-automation="model-next-button"
                onClick={(e) => {
                  onUpdate(e, customModel, 150);
                }}
                variant="contained"
                disabled={!customModel.length}
                size="large"
                endIcon={<Icon.ContinueIcon />}
              >
                Next
              </Button>
            ) : null}
          </NextStepButton>
        </StepGridContainer>
      </Step>
    </StepContainer>
  );
}

export default StepModel;
